export const url2filename = (url) => {
    const chunks = url.split('/');
    return chunks[chunks.length - 1];
}

export const downloadAsFile = (filename, data) => {
    let element = document.createElement('a');
    element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(data));
    element.setAttribute('download', filename);
    element.style.display = 'none';
    document.body.appendChild(element);
    element.click();
    document.body.removeChild(element);
};

export const checkFileType = (fileName) => {
    // Define regex for image and document file extensions
    const imagePattern = /\.(jpg|jpeg|png|gif|webp|jfif)$/i;
    const documentPattern = /\.(pdf|doc|docx|xls|xlsx|ppt|pptx|txt|kml)$/i;
    const linkPattern = /\.(com|org)$/i;
    const audioPattern = /\.(mp3|amr|wav)$/i;
    const videoPattern = /\.(mp4)$/i;

    if (imagePattern.test(fileName)) {
        return "image";
    } else if (documentPattern.test(fileName)) {
        return "document";
    } else if (linkPattern.test(fileName)) {
        return "link";
    } else if (audioPattern.test(fileName)) {
        return "audio";
    }
    else if (videoPattern.test(fileName)) {
        return "video";
    } else {
        return null;
    }
}
